import { all } from 'redux-saga/effects'
import authSaga from 'store/sagas/authSaga'
import teamSaga from 'store/sagas/teamSaga'
import companySaga from 'store/sagas/companySaga'
import contentsSaga from 'store/sagas/contentsSagas'
import templatesSaga from 'store/sagas/templateSagas'
import subscriptionSaga from 'store/sagas/subscriptionSaga'
import appSaga from 'store/sagas/appSagas'

export default function* rootSaga() {
  yield all([authSaga(), teamSaga(), companySaga(), contentsSaga(), templatesSaga(), subscriptionSaga(), appSaga()])
}
